import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { InfoCircleOutline } from '@aslanpay/portal-common-lib';

import { ProfileFieldProps } from './types';

function ProfileField({ label, value, tooltip = '' }: ProfileFieldProps) {
  return (
    <Flex gap="5px" flexDir="column" w="full">
      <Flex align="center" gap="6px">
        <Text color="brand.darkGray" textStyle="extraSmallRegular">
          {label}
        </Text>
        {tooltip && (
          <Tooltip hasArrow shouldWrapChildren arrowPadding={0} placement="top" label={tooltip}>
            <Flex>
              <InfoCircleOutline boxSize="24px" color="brand.darkGray" cursor="pointer" />
            </Flex>
          </Tooltip>
        )}
      </Flex>
      <Text py="15px" textStyle="smallMedium">
        {value || '-'}
      </Text>
    </Flex>
  );
}

export default ProfileField;
